/**
 * @module app.bdc.list.reportsListCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function ReportsListCtrl($rootScope, reportRoutingService, marketService) {
        var self = {};

        self.order = $rootScope.order;
        self.isReportsPanelOpened = false;

        /**
         * Toogle the reports panel
         */
        self.toggleOpenedReportsPanel = function() {
            self.isReportsPanelOpened = !self.isReportsPanelOpened;
        };

        /**
         * Open a report
         * @param  {String} reportName
         * @param  {String} option
         */
        self.openReport = function(reportName, option) {
            reportRoutingService.openReport(reportName, self.order, option);
        };

        /**
         * Open a PDF report
         * @param  {String} reportName
         * @param  {String} option
         */
        self.openReportPDF = function(reportName, option) {
            reportRoutingService.openReportPDF(reportName, self.order, option);
        };

        /* Markets */
        self.isBoulangerieMarket = marketService.isBoulangerieMarket(self.order);
        self.isTabacPresseMarket = marketService.isTabacPresseMarket(self.order);
        self.isLadditionMarket = marketService.isLadditionMarket(self.order);
        self.isFleuristeMarket = marketService.isFleuristeMarket(self.order);
        self.isAutreMarket = marketService.isAutreMarket(self.order);
        self.isFleuristeMarket = marketService.isFleuristeMarket(self.order);

        self.isLaddition = function() {
            return self.order.contract.isLaddition;
        };

        self.isLibrairie = function(){
            let option = self.order.options.find(opt => opt.label === 'LIBRAIRIE');
            return option || null;
        }

        /**
         * Is TPE option ?
         * @return {Boolean}
         */
        self.isTPE = function() {
            for (var i = 0; i < self.order.options.length; i++) {
                if (
                    self.order.options[i].optionType.code === 'TPE' ||
                    self.order.options[i].optionType.code === 'LADDITION_TPE'
                ) {
                    return true;
                }
            }
        };

        self.isA4Printer = function () {
            return self.order.options.find(o => o.optionType.code === 'IMPRIMANTE' && o.label !== 'Pas d\'imprimante Bimedia (Utilisation imprimante perso)')
        }

        /**
         * Is there a Scanup option in the order ?
         * @return {Boolean}
         */
        self.isScanup = function() {
            for (var i = 0; i < self.order.options.length; i++) {
                if (self.order.options[i].optionType.code === 'SCANUP') {
                    return true;
                }
            }
        };

        /**
         * Is there a Flashup option in the order ?
         * @return {Boolean}
         */
        self.isFlashup = function() {
            for (var i = 0; i < self.order.options.length; i++) {
                if (self.order.options[i].optionType.code === 'FLASHUP') {
                    return true;
                }
            }
        };

        return self;
    }

    ReportsListCtrl.$inject = ['$rootScope', 'reportRoutingService', 'marketService'];

    angular.module('app.bdc.list.reportsListCtrl', []).controller('ReportsListCtrl', ReportsListCtrl);
});
